const light = {
    dark: false,
    colors: {
        background: "#FAF5FF",
        surface: "#FFFFFF",
        primary: "#7A3AFF",
        "primary-lighten-1": "#9F80FF",
        "primary-lighten-2": "#CDC0F7",
        secondary: "#53bdd7",
        "on-secondary": "#FFFFFF",
        "surface-variant": "#f1f0fc",
        "on-surface-variant": "#37306c",
    },
};

const dark = {
    dark: true,
    colors: {
        background: "#1A1625",
        surface: "#2D2438",
        primary: "#9D6FFF",
        secondary: "#6ACCE2",
        "on-secondary": "#121212",
        "surface-variant": "#2a2440",
        "on-surface-variant": "#7aabea",
    },
};

export default {
    light,
    dark,
};
